module.exports = __webpack_public_path__ + "img/logo-bug.4518529a.svg";